// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoReportModal-cls1_U5h","cls2":"VideoReportModal-cls2_tNS VideoReportModal-cls1_U5h"};